/** The Passport client owns authentication, popup lifecycle and profile setup. */
export const PASSPORT_APP_NAME = 'Pubky';
export const PASSPORT_CLIENT_ID = 'pubky.app';
export const PASSPORT_DEFAULT_INSTANCE = 'https://passport.pubky.app';
